<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

interface Props {
  class?: HTMLAttributes['class']
}

defineProps<Props>()
</script>

<template>
  <div :class="cn('flex flex-col gap-2 px-3 py-4 border-b', $props.class)">
    <slot />
  </div>
</template>
